import { useState } from "react";

// ** Input
import SearchInput from "components/input-fields/SearchInput";

// ** Icons
import { IconButton } from "@mui/material";
import SearchIcon from "icons/SearchIcon";

export default function Search({ setSearch, placeholder, style }) {
  const [value, setValue] = useState("");
  return (
    <SearchInput
      disable_border="true"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      onKeyDown={(e) => e.key === "Enter" && setSearch(value)}
      startAdornment={null}
      style={style}
      endAdornment={
        <IconButton
          aria-label="search"
          size="small"
          variant="contained"
          onClick={() => setSearch(value)}
        >
          <SearchIcon
            fontSize="inherit"
            sx={{
              fontSize: 18,
              color: "text.disabled",
            }}
          />
        </IconButton>
      }
    />
  );
}
